function toggleSortMenu(sortButton) {
    if (sortButton) {
        sortButton.classList.toggle('is-active');
    }
}

function updateSelectedOption(clickedOption) {
    const customOptions = document.querySelectorAll('.facet-filters__sort-by ul li');
    const titleSpanDesktop = document.querySelector('.facet-filters__sort-by button span:first-child');
    const sortingForm = document.querySelector('#FacetFiltersForm');
    const selectElement = document.querySelector('#SortBy');

    if (customOptions && titleSpanDesktop && sortingForm && selectElement) {
        const optionValue = clickedOption?.dataset?.value;
        if (optionValue) {
            customOptions.forEach((optionLi) => {
                optionLi.classList.remove('selected');
            });

            const optionToSelect = Array.from(selectElement.options).find(item => item.value === optionValue);
            if (optionToSelect) {
                optionToSelect.selected = true;
            }
            sortingForm.dispatchEvent(new Event('input'));

            clickedOption.classList.add('selected');
            titleSpanDesktop.textContent = clickedOption.textContent;
        }
    }
}